export const GET_EXCO_PUSAT = "GET_EXCO_PUSAT";
export const GET_EXCO_PUSAT_SUCCESS = "GET_EXCO_PUSAT_SUCCESS";
export const GET_EXCO_PUSAT_FAIL = "GET_EXCO_PUSAT_FAIL";

// detail exco
export const GET_DETAIL_EXCO_PUSAT = "GET_DETAIL_EXCO_PUSAT";
export const GET_DETAIL_EXCO_PUSAT_SUCCESS = "GET_DETAIL_EXCO_PUSAT_SUCCESS";
export const GET_DETAIL_EXCO_PUSAT_FAIL = "GET_DETAIL_EXCO_PUSAT_FAIL";

// patch alamat kantor exco
export const PATCH_EXCO_PUSAT = "PATCH_EXCO_PUSAT";
export const PATCH_EXCO_PUSAT_SUCCESS = "PATCH_EXCO_PUSAT_SUCCESS";
export const PATCH_EXCO_PUSAT_FAIL = "PATCH_EXCO_PUSAT_FAIL";

// get exco rt rw
export const GET_EXCO_RTRW = "GET_EXCO_RTRW";
export const GET_EXCO_RTRW_SUCCESS = "GET_EXCO_RTRW_SUCCESS";
export const GET_EXCO_RTRW_FAIL = "GET_EXCO_RTRW_FAIL";

// get exco puk
export const GET_EXCO_PUK = "GET_EXCO_PUK";
export const GET_EXCO_PUK_SUCCESS = "GET_EXCO_PUK_SUCCESS";
export const GET_EXCO_PUK_FAIL = "GET_EXCO_PUK_FAIL";

// create exco puk
export const CREATE_EXCO_PUK = "CREATE_EXCO_PUK";
export const CREATE_EXCO_PUK_SUCCESS = "CREATE_EXCO_PUK_SUCCESS";
export const CREATE_EXCO_PUK_FAIL = "CREATE_EXCO_PUK_FAIL";

// create exco rt rw
export const CREATE_EXCO_RTRW = "CREATE_EXCO_RTRW";
export const CREATE_EXCO_RTRW_SUCCESS = "CREATE_EXCO_RTRW_SUCCESS";
export const CREATE_EXCO_RTRW_FAIL = "CREATE_EXCO_RTRW_FAIL";
